import React from 'react';
export function Footer() {
  return <footer className="border-t border-navy-line bg-navy-deep px-3 py-3 text-center sm:px-6" data-id="element-71" data-mp="32wd2qgad7ltj">
      <p className="text-[0.66rem] font-semibold text-white/85 sm:text-[0.76rem]" data-id="element-72" data-mp="3ggtwodvnbb34">
        © 2026 FIBER OPTIC DIAGNOSTIC PRO™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-1 max-w-2xl text-[0.62rem] leading-[1.45] text-white/60 sm:text-[0.72rem]" data-id="element-73" data-mp="36oy0x9h17x22">
        FIBER OPTIC DIAGNOSTIC PRO™ is an educational and professional reference resource. It does not guarantee
        successful fault identification or repair and does not replace appropriate testing equipment, manufacturer
        instructions, applicable safety requirements, professional qualifications, or qualified technical judgment.
      </p>
      <p className="mt-1 text-[0.62rem] text-white/60 sm:text-[0.72rem]" data-id="element-74" data-mp="3qfjhaeexf9n2">
        <a href="#" className="transition-colors duration-150 ease-out hover:text-signal" data-id="element-75" data-mp="29xlzsm95j0i1">
          Terms &amp; Conditions
        </a>{' '}
        •{' '}
        <a href="#" className="transition-colors duration-150 ease-out hover:text-signal" data-id="element-76" data-mp="3l90m9rokaqx5">
          Privacy Policy
        </a>{' '}
        •{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-signal" data-id="element-77" data-mp="3gc0jbpn0e4a9">
          Contact
        </a>
      </p>
      <p className="mt-0.5 text-[0.62rem] text-white/60 sm:text-[0.72rem]" data-id="element-78" data-mp="3q83shfga336p">
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-signal" data-id="element-79" data-mp="82ibxqv2w6ds">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}